import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import DataTable from "datatables.net";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import { useHistory } from "react-router";
import { toAbsoluteUrl } from "../../../_metronic/_helpers/index.js";
import SVG from "react-inlinesvg";
import alertify from "alertifyjs";
import { date_format, datetime_format } from "../Common/DateFormat.js";
import { API_URL, BACKEND_URL } from "../constants.js";
import {
  printReportUrl,
  printInvoiceUrl,
  printPatientDetailUrl,
  patientEditUrl,
  patientDuplicateUrl,
  getPatientSampleId,
} from "../Common/patientIdentifier";
import PrintIcon from "@material-ui/icons/Print";
import DescriptionIcon from "@material-ui/icons/Description";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import EditIcon from "@material-ui/icons/Edit";
import BeachAccessIcon from "@material-ui/icons/BeachAccess";
import ArchiveIcon from "@material-ui/icons/Archive";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import UnarchiveIcon from "@material-ui/icons/Unarchive";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls/index.js";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";

export function ArchiveSamples(props) {
  const { t } = useTranslation();
  const [patients, setPatients] = useState([]);
  const [patient, setPatient] = useState(null);
  const [show, setShow] = useState(false);
  const [action, setAction] = useState("patient");
  const [disabled, setDisabled] = useState(false);
  const history = useHistory();

  const setCurrentPatient = (patient, action) => {
    setPatient(patient);
    setAction(action);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  const deletePatient = () => {
    axios
      .post(API_URL + "patient/delete", {
        id: patient,
        action: action,
      })
      .then((response) => {
        if (response.data.status) {
          history.go(0);
          setShow(false);
          alertify.success(response.data.message);
        } else {
          alertify.error(response.data.message);
          return null;
        }
      });
  };

  const unarchivePatient = (id) => {
    setDisabled(true);
    axios
      .post(API_URL + `patient/${id}/unarchive`)
      .then((response) => {
        setDisabled(false);
        if (response.data.status) {
          alertify.success(response.data.message || "Patient unarchived successfully");
          // Refresh the page to update the list
          history.go(0);
        } else {
          alertify.error(response.data.message || "Failed to unarchive patient");
        }
      })
      .catch((error) => {
        setDisabled(false);
        alertify.error("Error unarchiving patient");
        console.error("Unarchive error:", error);
      });
  };

  useEffect(() => {
    axios
      .get(API_URL + "patient/get-archive")
      .then((response) => {
        if (response.data.status) {
          const archivePatients = response.data.data.patients;
          setPatients(archivePatients);
          console.log("archive", patients);
          $("#patient_table").DataTable();
        } else {
          alertify.error(response.data.message);
          return null;
        }
      })
      .catch((error) => {
        if (error.message === "Request failed with status code 401") {
          //props.logout();
        }
      });
  }, []);

  return (
    <>
      <style>{`.patient-actions .btn:hover svg { color: currentColor !important; }`}</style>
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader title={t("Archive Patients List")}>
              <CardHeaderToolbar>
                <Button
                  as={Link}
                  to="/patients-with-report"
                  variant="primary"
                >
                  Generate Report
                </Button>
              </CardHeaderToolbar>
            </CardHeader>
            <CardBody style={{ overflow: "auto" }}>
              <table
                id="patient_table"
                className="stratprop_datatable table table-striped table-bordered"
              >
                <thead>
                  <tr key={"thead"}>
                    <th>{t("UnArchive")}</th>
                    <th>{t("SN.")}</th>
                    {/* <th>{t("Actions")}</th> */}
                    <th>{t("Sample ID")}</th>
                    <th>{t("First Name")}</th>
                    <th>{t("Last Name")}</th>
                    <th>{t("Passport")}</th>
                    <th>{t("Collection At")}</th>
                    {/*<th>{t("Collection Time")}</th>*/}
                    <th>{t("Gender")}</th>
                    <th>{t("D.O.B")}</th>
                    {/*<th>{t("Phone")}</th>*/}
                    <th>{t("Email")}</th>
                    <th>{t("Status")}</th>
                  </tr>
                </thead>
                <tbody>
                  {patients.length > 0 ? (
                    patients.map((patient, index) => (
                      <tr key={patient.id}>
                        <td>
                          <div className="d-flex flex-wrap patient-actions">
                            <a
                              title="UnArchive Patient"
                              onClick={() => unarchivePatient(patient.id)}
                              disabled={disabled}
                              className="btn btn-outline-success m-1"
                              style={{ width: "42px", cursor: disabled ? "not-allowed" : "pointer" }}
                            >
                              <UnarchiveIcon color="inherit" />
                            </a>
                          </div>
                        </td>
                        <td>{index + 1}</td>
                        {/* <td>
                          <div>
                            <Link
                              to={`/patient/edit/${patient.id}`}
                              title={"Edit Patient"}
                              className="btn-icon btn-light btn-hover-primary mx-3"
                            >
                              <EditIcon color="primary"></EditIcon>
                            </Link>
                            <a
                              href={printPatientDetailUrl(patient.sample_id)}
                              target={"_blank"}
                              className="btn-icon btn-hover-warning mx-3"
                              title={"View Patient Detail"}
                            >
                              <BeachAccessIcon color="primary"></BeachAccessIcon>
                            </a>
                            <a
                              href={printInvoiceUrl(patient.sample_id)}
                              target={"_blank"}
                              className="btn-icon btn-hover-warning mx-3"
                              title={"Print Invoice"}
                            >
                              <PrintIcon color="primary"></PrintIcon>
                            </a>
                            <a
                              href={printReportUrl(patient.sample_id)}
                              target={"_blank"}
                              className="btn-icon btn-hover-warning mx-3"
                              title={"Print Report"}
                            >
                              <DescriptionIcon color="primary"></DescriptionIcon>
                            </a>
                            <a
                              title={"Delete Patient Record"}
                              onClick={() =>
                                setCurrentPatient(patient.id, "patient")
                              }
                              className="btn-icon btn-light btn-hover-danger mx-3"
                            >
                              <DeleteForeverIcon color="secondary"></DeleteForeverIcon>
                            </a>
                            <a
                              title={"Delete Patient Report"}
                              onClick={() =>
                                setCurrentPatient(patient.id, "report")
                              }
                              className="btn-icon btn-light btn-hover-danger mx-3"
                            >
                              <HighlightOffIcon color="secondary"></HighlightOffIcon>
                            </a>

                            <Link
                              to={`/patient/duplicate/${patient.id}`}
                              className="btn-icon btn-light btn-hover-primary mx-3"
                              title="Duplicate Patient"
                            >
                              <FileCopyIcon
                                className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10"
                                color="primary"
                              />
                            </Link>
                          </div>
                        </td> */}
                        <td>{patient.sample_id}</td>
                        <td>{patient.first_name}</td>
                        <td>{patient.last_name}</td>
                        <td>{patient.passport_number}</td>
                        {/*<td>{(patient.registered_at) ? datetime_format(patient.registered_at) : ""}</td>*/}
                        <td>
                          {patient.collection_datetime
                            ? datetime_format(patient.collection_datetime)
                            : ""}
                        </td>
                        <td>{patient.gender}</td>
                        <td>{patient.dob ? date_format(patient.dob) : ""}</td>
                        {/*<td>{patient.phone_no}</td>*/}
                        <td>{patient.email}</td>
                        <td>{patient.report_status.name}</td>
                      </tr>
                    ))
                  ) : (
                    <tr key={"nopatient"}>
                      <td colSpan={14}>No Patient</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("Delete Patient / Report")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("Are you sure you want to Delete?")}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Close")}
          </Button>
          <Button variant="primary" onClick={deletePatient}>
            {t("Confirm")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
